import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import config from '../config'

const { api } = config

// default
axios.defaults.baseURL = api.API_URL

// Read token fresh from sessionStorage on each request
axios.interceptors.request.use(
  function (config) {
    const token = sessionStorage.getItem('jwtToken')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message
    switch (error.response?.status) {
      case 500:
        message =
          error.response?.data?.error ??
          error.response?.data?.message ??
          error.response?.data?.msg ??
          'Internal Server Error'
        break
      case 401:
        message =
          error.response?.data?.error ??
          error.response?.data?.message ??
          'Oturum süresi dolmuş. Lütfen tekrar giriş yapın.'
        break
      case 400:
        message =
          error.response?.data?.error ??
          error.response?.data?.message ??
          error.response?.data?.msg ??
          'Bad Request'
        break
      case 404:
        message =
          error.response?.data?.error ??
          error.response?.data?.message ??
          error.response?.data?.msg ??
          'Kayıt bulunamadı.'
        break
      case 409:
        message =
          error.response?.data?.message ??
          error.response?.data?.error ??
          'Bu kayıt zaten mevcut.'
        break
      default:
        message =
          error.response?.data?.error ??
          error.response?.data?.message ??
          error.response?.data?.msg ??
          (error.message || error)
    }
    return Promise.reject(message)
  }
)
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: any) => {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

export interface AxiosRes extends AxiosResponse {
  statusCode: number | string
  success: string | boolean | undefined
  message: string
  data: any
  totalPages: number
  token?: string
  user?: any
}

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url: any, params: any): Promise<AxiosRes> => {
    let paramKeys: any = []
    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + '=' + params[key])
        return paramKeys
      })

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : ''
      return axios.get(`${url}?${queryString}`, params)
    } else {
      return axios.get(`${url}`, params)
    }
  }
  /**
   * post given data to url
   */
  create = (url: any, data: any): Promise<AxiosRes> => {
    return axios.post(url, data)
  }
  /**
   * Updates data
   */
  update = (url: any, data: any): Promise<AxiosRes> => {
    return axios.patch(url, data)
  }

  put = (url: any, data: any): Promise<AxiosRes> => {
    return axios.put(url, data)
  }
  /**
   * Delete
   */
  delete = (url: string, config?: AxiosRequestConfig): Promise<AxiosRes> => {
    return axios.delete(url, { ...config })
  }
}
const getLoggedinUser = () => {
  const user = sessionStorage.getItem('authUser')
  if (!user) {
    return null
  } else {
    return JSON.parse(user)
  }
}

export { APIClient, setAuthorization, getLoggedinUser }
